<template>
  <AnalyticsChartLayout :chart-info-list="tokenChartList" />
</template>

<script lang="ts" setup>
import AnalyticsChartLayout from '~/components/@pages/analytics/AnalyticsChartLayout.vue'
import { ANALYTICS_CHART_API } from '~/constants/analytics.constants'

const tokenChartList = Object.entries(ANALYTICS_CHART_API).filter(([ key, value ]) => {
  return key.includes('token')
})
</script>

<style lang="scss" scoped>

</style>